<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    :title="title"
    color="#ed7d31"
  >
    <div
      class="ActionNode_text"
      v-html="text"
    ></div>
    <InlineError
      v-if="node.actionType === 'SEND_SMS' && selectedSmsStatus && selectedSmsStatus !== 'active'"
      class="ActionNode_Error"
    >
      {{$t(`common.status.${selectedSmsStatus}`)}}
    </InlineError>

  </BaseNode>
</template>

<script>
import nodeMixin from './nodeMixin'
import {formatActionDataItem} from '../../api/format.ts'

export default {
  mixins: [nodeMixin],
  computed: {
    title() {
      const {actionType} = this.node
      if (actionType === 'SEND_TO_RECOMMENDATION') {
        return this.$t('common.Product Recommendation')
      } else if (actionType === 'SEND_TO_ENDPOINT') {
        return this.$t('common.Send to Endpoint')
      } else if (actionType === 'SEND_NOTIFICATION') {
        return this.$t('common.Send Notification')
      } else if (actionType === 'UPDATE_USER_DATA') {
        return this.$t('common.Update User Data')
      } else if (actionType === 'SEND_SMS') {
        return this.$t('common.Send SMS Message')
      }
      return this.$t('common.[unknown]')
    },
    selectedSmsStatus() {
      const {actionType, actionId} = this.node
      if (actionType === 'SEND_SMS') {
        const item = this.account.smsMessages.find(d => d.id === actionId)
        return item && item.status
      }
      return null
    },
    text() {
      const {actionType, actionId} = this.node
      let text = ''
      if (actionType === 'SEND_TO_RECOMMENDATION') {
        text = this.$t('common.Send to Product Recommendation Service')
      } else if (actionType === 'SEND_TO_ENDPOINT') {
        const item = this.account.esps.find(d => d.id === actionId)
        const name = item ? item.name : this.$t('common.[UNDEFINED]')
        text = name
        const {
          fillRecommendation,
          // fillIntoProducts,
          numProductsToFill
        } = this.node
        if (fillRecommendation) {
          text += `<div class="ActionNode_note">+ ${this.$t('common.includeXProductRecommendations', { num: `${numProductsToFill}` })}</div>`
        }
      } else if (actionType === 'SEND_NOTIFICATION') {
        const item = this.account.notifications.find(d => d.id === actionId)
        const name = item ? item.name : this.$t('common.[UNDEFINED]')
        text = name
      } else if (actionType === 'SEND_SMS') {
        const item = this.account.smsMessages.find(d => d.id === actionId)
        const name = item ? item.name : this.$t('common.[UNDEFINED]')
        text = name
      } else if (actionType === 'UPDATE_USER_DATA') {
        text = this.node.dataItems
          .map(item => formatActionDataItem(item))
          .join('<br>')
      }
      return text
    }
  }
}
</script>

<style lang="scss">
.ActionNode {
  .BaseNode_content {
    min-width: 200px;
  }
}

.ActionNode_text {
  max-width: 250px;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ActionNode_note {
  max-width: 250px;
  margin-top: 5px;
  color: #800080;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ActionNode_Error {
  font-size: 11px;
  margin: 0px;
}
</style>
